
/* Break an array (arr) into an array of arrays of length===size
 * */
function chunk(arr: Array, size: Number) : Array<any> {
  const sizeNum = Number(size);
  const newArr = [];
  for (let i = 0; i < arr.length; i += sizeNum) {
    newArr.push(arr.slice(i, i + sizeNum));
  }
  return newArr;
}

export default { chunk };



// WEBPACK FOOTER //
// ./src/js/libs/ArrayMethods.js